import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "bg-white p-2" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "d-flex align-center" }
const _hoisted_5 = { class: "w-50" }
const _hoisted_6 = { class: "d-flex align-center justify-space-between mb-2" }
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = { class: "fw-bold" }
const _hoisted_9 = { class: "d-flex border-top border-bottom" }
const _hoisted_10 = { class: "w-33 pe-2 py-2" }
const _hoisted_11 = { class: "d-flex align-center" }
const _hoisted_12 = { class: "text-align-right" }
const _hoisted_13 = { class: "w-33 border-left px-2 py-2" }
const _hoisted_14 = { class: "d-flex align-center" }
const _hoisted_15 = { class: "text-align-right" }
const _hoisted_16 = { class: "text-h4" }
const _hoisted_17 = { class: "w-33 border-left ps-2 py-2" }
const _hoisted_18 = { class: "d-flex align-center" }
const _hoisted_19 = { class: "ms-1 text-caption" }
const _hoisted_20 = { class: "text-align-right" }
const _hoisted_21 = { class: "text-h4" }
const _hoisted_22 = { class: "d-flex" }
const _hoisted_23 = {
  key: 1,
  class: "dashboard-stats-wrapper"
}
const _hoisted_24 = { class: "dashboard-stats-container" }
const _hoisted_25 = { class: "stats-progress" }
const _hoisted_26 = { class: "d-flex justify-space-between" }
const _hoisted_27 = { class: "fw-bold" }
const _hoisted_28 = { class: "mt-2" }
const _hoisted_29 = { class: "fw-bold" }
const _hoisted_30 = { class: "stats-time" }
const _hoisted_31 = { class: "d-flex flex-row justify-space-between align-center" }
const _hoisted_32 = { class: "text-08rem" }
const _hoisted_33 = { class: "ms-3" }
const _hoisted_34 = { class: "stats-counters" }
const _hoisted_35 = { class: "stats-counter-item" }
const _hoisted_36 = { class: "d-flex align-center" }
const _hoisted_37 = { class: "ms-1 text-caption" }
const _hoisted_38 = { class: "text-h4" }
const _hoisted_39 = { class: "stats-counter-item" }
const _hoisted_40 = { class: "d-flex align-center" }
const _hoisted_41 = { class: "text-h4" }
const _hoisted_42 = {
  key: 1,
  class: "p-3 mt-3 bg-white"
}
const _hoisted_43 = { class: "d-flex justify-space-between" }
const _hoisted_44 = { class: "text-x-large font-bold" }
const _hoisted_45 = { class: "bg-white px-2 py-1 mt-2 info-content" }
const _hoisted_46 = ["innerHTML"]
const _hoisted_47 = {
  key: 2,
  class: "p-3 mt-3",
  style: {"background":"#FFFFF0"}
}
const _hoisted_48 = { class: "d-flex justify-space-between" }
const _hoisted_49 = { class: "text-small" }
const _hoisted_50 = { class: "bg-white border-default px-2 py-1 mt-2" }
const _hoisted_51 = { class: "d-flex justify-end mt-1" }
const _hoisted_52 = {
  key: 3,
  class: "bg-white p-3 mt-3"
}
const _hoisted_53 = { class: "gray--text font-weight-bold" }
const _hoisted_54 = { class: "row" }
const _hoisted_55 = { class: "col-md-3 col-sm-12" }
const _hoisted_56 = { class: "col-md-6 col-sm-12" }
const _hoisted_57 = { class: "mt-2 mb-1" }
const _hoisted_58 = { class: "d-flex align-items-center" }
const _hoisted_59 = { class: "font-bold ms-2" }
const _hoisted_60 = { class: "col-md-3 col-sm-12" }
const _hoisted_61 = { class: "d-flex flex-row align-self-center justify-content-center" }
const _hoisted_62 = { style: {"line-height":"1","text-align":"center"} }
const _hoisted_63 = { style: {"font-size":"xx-large"} }
const _hoisted_64 = { class: "mt-2 text-center" }
const _hoisted_65 = { class: "bg-white p-3 mt-3 dashboard-courses-section" }
const _hoisted_66 = { class: "gray--text" }
const _hoisted_67 = {
  key: 0,
  class: "d-flex justify-end mt-4 me-4"
}
const _hoisted_68 = {
  key: 0,
  class: "mt-5"
}
const _hoisted_69 = { class: "gray--text" }
const _hoisted_70 = {
  key: 0,
  class: "d-flex justify-end mt-3 me-4"
}
const _hoisted_71 = ["innerHTML"]
const _hoisted_72 = {
  "aria-label": "AIチャット",
  "data-bs-toggle": "modal",
  "data-bs-target": "#dashboard_ai_chat",
  class: "dashboard-chat-fab"
}
const _hoisted_73 = ["src"]
const _hoisted_74 = {
  class: "modal fade lessonTabModal",
  id: "dashboard_ai_chat",
  tabindex: "-1",
  "aria-labelledby": "AIチャット",
  "aria-hidden": "true",
  style: {"max-height":"100%","height":"100%","min-height":"100%","overflow-y":"hidden","overflow-x":"hidden"}
}
const _hoisted_75 = {
  class: "modal-dialog slideUpModal modal-dialog-scrollable modal-fullscreen bg-white",
  style: {"max-height":"100%","height":"100%","min-height":"100%","overflow-y":"hidden","overflow-x":"hidden"}
}
const _hoisted_76 = { class: "modal-content" }
const _hoisted_77 = { class: "modal-body" }
const _hoisted_78 = ["innerHTML"]
const _hoisted_79 = {
  key: 0,
  class: "col-4 p-0"
}
const _hoisted_80 = ["innerHTML"]
const _hoisted_81 = {
  key: 1,
  class: "dashboard-chat-container",
  style: { position: 'relative', paddingLeft: '4px' }
}
const _hoisted_82 = ["innerHTML"]

import { ref, computed, watch, onBeforeUnmount, nextTick } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import CourseList from '../pages/CourseList.vue'
import DashboardChart from './DashboardChart.vue'
import SubPage from '../atoms_molecules/SubPage.vue'
import { headerState } from '../../stores/header'
import { footerState } from '../../stores/footer'
import Banner from '../../../api/v2/models/banner'
import Exam from '../organisms/Exam.vue'
import Enrollment from '../../../api/v2/models/enrollment'
import UserGoal from '../../../api/v2/models/user_goal'
import CourseMy from '../atoms_molecules/CourseMy.vue'
import DashboardProgress from '../atoms_molecules/DashboardProgress.vue'
import InformationView from '../atoms_molecules/InformationView.vue'
import DashboardTimeSummary from '../atoms_molecules/DashboardTimeSummary.vue'
import UserTimeGoalChangeDialog from '../atoms_molecules/UserTimeGoalChangeDialog.vue'
import DashboardChatTabs from '../atoms_molecules/DashboardChatTabs.vue'
import api from '../../../api/v2/api'
import { subWeeks, getISODay, format, addDays } from 'date-fns'
import UserTrackingData from '../../../api/v2/models/user_tracking_data'
import LearningStatsData from '../../../api/v2/models/learning_stats_data'
import { userState } from '../../stores/user'
import { checkMobile } from '../../utils/utils'
import { ROUTER_NAME } from '../../router'
import { sum } from 'lodash'
import Information from '../../../api/v2/models/information'
import ExamModel from '../../../api/v2/models/exam'
import { convertMinutesToTimeJp } from '../../../../lib/convert'
import { examMyState } from '../../stores/exam_my'
import { PageModeType } from '../../types'
import { getQueryString } from '../../../../helpers/route-helper'

export default /*@__PURE__*/_defineComponent({
  __name: 'Dashboard',
  setup(__props) {

const RobotImg = require("../../../../images/robot.png").default || require("../../../../images/robot.png")

const route = useRoute()
const router = useRouter()

// Refs
const dashboardChatTabs = ref<InstanceType<typeof DashboardChatTabs> | null>(null)

// Reactive Data
const mobile = ref(checkMobile())
const banners = ref<Banner[]>([])
const agentAvatarUrl = ref<string | null>(null)
const agentDefaultAvatar = ref<string>(RobotImg)
const rightPanelWidth = ref(400)
const isResizing = ref(false)
const startX = ref(0)
const startWidth = ref(0)
const exams = ref<ExamModel[]>([])
const enrollments = ref<Enrollment[]>([])
const userGoal = ref<UserGoal | null>(null)
const userGoalsCount = ref(0)
const userTrackingData = ref<UserTrackingData | null>(null)
const activitiesData = ref<any[]>([])
const learningStatsData = ref<LearningStatsData | null>(null)
const useNewStats = computed(() => userState.user?.learningStatsReadSource === 'new')
// 旧方式(UserTrackingData)・新方式(LearningStatsData)どちらでも .labels/.trackingUserValues/.consecutiveDayCount が同じ形
const activeTrackingData = computed(() => {
  if (!useNewStats.value) return userTrackingData.value
  if (!learningStatsData.value || !userTrackingData.value) return null

  const values = userTrackingData.value.labels.map((date, index) => {
    const dateStr = format(new Date(date), 'YYYY-MM-DD')
    if (learningStatsData.value!.isLegacyEstimate(dateStr) || userTrackingData.value!.isManuallyChanged(dateStr)) {
      return userTrackingData.value!.trackingUserValues[index]
    }
    return learningStatsData.value!.days.find((day) => day.date === dateStr)?.totalActiveMinutes ?? 0
  })
  let consecutiveDayCount = 0
  for (let i = values.length - 1; i >= 0 && values[i] > 0; i--) consecutiveDayCount++

  return { labels: userTrackingData.value.labels, trackingUserValues: values, consecutiveDayCount }
})
const dateRange = ref({
  startDate: addDays(subWeeks(new Date(), 1), 1),
  endDate: new Date()
})
const pageMode = ref<PageModeType>('main_page')
const subPageExam = ref<ExamModel | null>(null)

// Computed
const user = computed(() => userState.user)
const schoolSetting = computed(() => headerState.schoolSetting)
const customTexts = computed(() => headerState.customTexts)

const mainContentClass = computed(() => {
  if (!schoolSetting.value?.useDashboardAi) {
    if (mobile.value) {
      return 'w-100'
    }
    return 'col-9'
  } else {
    if (mobile.value) {
      return 'dashboard-content-scroll'
    }
    // Desktop với AI chat: dùng grid layout, không cần col-*
    if (showAiChatDesktop.value) {
      return 'dashboard-content-scroll'
    }
    return 'col-8 dashboard-content-scroll'
  }
})

const showAiChatMobile = computed(() => mobile.value && schoolSetting.value?.useDashboardAi)
const showAiChatDesktop = computed(() => !mobile.value && schoolSetting.value?.useDashboardAi)



const isMoreExam = computed(() => exams.value.length > 3)
const firstEnrollments = computed(() => enrollments.value.slice(0, 3))
const currentUserGoal = computed(() => userGoal.value)
const totalUserGoalsCount = computed(() => userGoalsCount.value - 1 > 0 ? userGoalsCount.value - 1 : 0)
const isMoreCourse = computed(() => firstEnrollments.value.length < enrollments.value.length)
const unreadInformations = computed(() => user.value ? user.value.unreadInformations : [])
const latestiUnreadInformations = computed(() => user.value ? user.value.unreadInformations.slice(0, 3) : [])
const learnTimeGoalMinutes = computed(() => userState.user ? userState.user.learnTimeGoalMinutes : 0)
const learnTimeToTimeJp = computed(() => convertMinutesToTimeJp(learnTimeGoalMinutes.value))

const timeGraphData = computed(() => {
  if (!activeTrackingData.value) {
    return null
  }
  return {
    labels: activeTrackingData.value.labels.map((date) => {
      switch (getISODay(new Date(date))) {
        case 1: return '月'
        case 2: return '火'
        case 3: return '水'
        case 4: return '木'
        case 5: return '金'
        case 6: return '土'
        case 7: return '日'
      }
    }),
    datasets: [
      {
        label: '学習時間',
        backgroundColor: '#44a2eb',
        fill: false,
        data: activeTrackingData.value.trackingUserValues
      }
    ]
  }
})

const computedActivityCount = computed(() => {
  if (useNewStats.value) {
    if (!learningStatsData.value || !userTrackingData.value) return 0
    return sum(userTrackingData.value.labels.map((label: string) => {
      const dateStr = format(new Date(label), 'YYYY-MM-DD')
      if (!learningStatsData.value!.isLegacyEstimate(dateStr)) {
        return learningStatsData.value!.days.find((day) => day.date === dateStr)?.completedLessonCount ?? 0
      }
      return activitiesData.value.filter((activity: any) => format(new Date(activity.createdAt), 'YYYY-MM-DD') === dateStr).length
    }))
  }

  if (!userTrackingData.value || !userTrackingData.value.labels) {
    return 0
  }
  const dailyCounts = userTrackingData.value.labels.map((label: string) => {
    const dateStr = format(new Date(label), 'YYYY-MM-DD')
    const activitiesForDate = activitiesData.value.filter((act: any) => {
      const actDateStr = format(new Date(act.createdAt), 'YYYY-MM-DD')
      return actDateStr === dateStr
    })
    return activitiesForDate.length
  })
  return sum(dailyCounts)
})

const activityCount = computed(() => computedActivityCount.value)

const totalLearnTimeMinutes = computed(() => {
  if (!activeTrackingData.value) {
    return 0
  }
  return sum(activeTrackingData.value.trackingUserValues)
})

const totalLearnTimeToTimeJp = computed(() => convertMinutesToTimeJp(totalLearnTimeMinutes.value))

const learnProgressRate = computed(() => {
  if (!learnTimeGoalMinutes.value) {
    return 0
  }
  return Math.round((totalLearnTimeMinutes.value / learnTimeGoalMinutes.value) * 100)
})

const consecutiveDayCount = computed(() => {
  if (!activeTrackingData.value) {
    return 0
  }
  return activeTrackingData.value.consecutiveDayCount
})

const totalTime = computed(() => {
  if (!userTrackingData.value) {
    return 0
  }
  let total = 0
  userTrackingData.value.trackingUserValues.forEach((value) => {
    total += value
  })
  return total
})

const examIdQuery = computed(() => getQueryString(route.query, 'exam_id'))
const schoolId = computed(() => user.value?.currentSchoolId || 0)
const dashboardChatThreadId = computed(() => `dashboard_${userState.user?.id || 0}_${schoolId.value}`)
const hasDashboardTopBanner = computed(() => !!getBanner('user_dashboard_sidebar_top'))

// Functions
async function fetchTrackingData() {
  if (useNewStats.value) {
    const [newStats, legacyStats, legacyActivities] = await Promise.all([
      api.learningStats.dailySeries(dateRange.value),
      api.tracking.get(dateRange.value),
      api.activity.get(0, dateRange.value)
    ])
    learningStatsData.value = newStats
    userTrackingData.value = legacyStats
    activitiesData.value = legacyActivities.activities || []
    return
  }
  userTrackingData.value = await api.tracking.get(dateRange.value)
}

async function updateTimeGoal(learnTimeGoalValue: number) {
  await userState.updateLearnTimeGoalValue({ learnTimeGoalValue })
  // Refetch tracking data để chart cập nhật realtime
  fetchTrackingData()
}

function onSwitchMode(mode: PageModeType) {
  pageMode.value = mode
  router.push({
    query: {
      ...(route.query ?? {}),
      exam_id: undefined
    }
  })
}

function onShowHistories(exam: ExamModel) {
  pageMode.value = 'sub_page'
  subPageExam.value = exam
  router.push({
    query: {
      ...(route.query ?? {}),
      exam_id: exam.id.toString()
    }
  })
}

function refetchList() {
  examMyState.getMyExams().then(() => {
    exams.value = examMyState.list
    if (examIdQuery.value) {
      const found = exams.value.find((item) => item.id.toString() === examIdQuery.value)
      if (found) {
        onShowHistories(found)
      }
    }
    if (subPageExam.value) {
      const found = exams.value.find((item) => item.id === subPageExam.value!.id)
      if (found) {
        subPageExam.value = found
      }
    }
  })
}

function getBanner(position: string): Banner | undefined {
  return banners.value.find((banner) => banner.position === position)
}

const getSideBarBanner = computed(() => {
  const banner = getBanner('user_dashboard_sidebar_top')
  return banner ? banner.bodyHtml : ''
})

function dateFormat(date: any, formatDate: string = 'YYYY年MM月DD日'): string {
  return format(date, formatDate)
}

function toActivity() {
  router.push({
    name: ROUTER_NAME.ACTIVITY_LIST
  })
}

function toInfo(info: Information) {
  router.push({
    name: ROUTER_NAME.INFOR_DETAIL,
    params: { inforId: info.id.toString() }
  })
}

function readInformation(info: Information) {
  api.infor.show(info.id.toString()).then(() => {
    userState.getUser()
  })
}

function goToUserGoal(userGoalItem: UserGoal) {
  router.push({
    name: ROUTER_NAME.USER_GOAL_DETAIL,
    params: { userGoalId: userGoalItem.id.toString() }
  })
}

function goToUserGoals() {
  router.push({ name: ROUTER_NAME.USER_GOAL_LIST })
}

function startResize(e: MouseEvent) {
  isResizing.value = true
  startX.value = e.clientX
  startWidth.value = rightPanelWidth.value
  document.addEventListener('mousemove', doResize)
  document.addEventListener('mouseup', stopResize)
  document.body.style.cursor = 'col-resize'
  document.body.style.userSelect = 'none'
  e.preventDefault()
}

function doResize(e: MouseEvent) {
  if (!isResizing.value) return
  const deltaX = startX.value - e.clientX
  const newWidth = Math.min(Math.max(startWidth.value + deltaX, 300), window.innerWidth * 0.6)
  rightPanelWidth.value = newWidth
  savePanelWidth()
  
  nextTick(() => {
    if (dashboardChatTabs.value && (dashboardChatTabs.value as any).handleDashboardResize) {
      (dashboardChatTabs.value as any).handleDashboardResize()
    }
  })
}

function stopResize() {
  isResizing.value = false
  document.removeEventListener('mousemove', doResize)
  document.removeEventListener('mouseup', stopResize)
  document.body.style.cursor = ''
  document.body.style.userSelect = ''
}

function resetPanelWidth() {
  rightPanelWidth.value = 400
  savePanelWidth()
}

function savePanelWidth() {
  localStorage.setItem('dashboard_right_panel_width', rightPanelWidth.value.toString())
}

function loadPanelWidth() {
  const saved = localStorage.getItem('dashboard_right_panel_width')
  if (saved) {
    rightPanelWidth.value = parseInt(saved, 10)
  } else {
    // Responsive default: smaller panel on medium screens
    const vw = window.innerWidth
    if (vw < 1100) {
      rightPanelWidth.value = Math.max(300, Math.floor(vw * 0.35))
    } else {
      rightPanelWidth.value = 400
    }
  }
}

// Lifecycle
onBeforeUnmount(() => {
  if (isResizing.value) {
    stopResize()
  }
  // Remove no-scroll class when leaving dashboard
  if (showAiChatDesktop.value) {
    document.documentElement.classList.remove('no-scroll')
    document.body.classList.remove('no-scroll')
  }
})

// Watch for AI chat desktop to add/remove no-scroll class
watch(showAiChatDesktop, (newVal) => {
  if (newVal) {
    document.documentElement.classList.add('no-scroll')
    document.body.classList.add('no-scroll')
  } else {
    document.documentElement.classList.remove('no-scroll')
    document.body.classList.remove('no-scroll')
  }
}, { immediate: true })

// Created logic (runs immediately)
;(async () => {
  loadPanelWidth()
  footerState.setFooterDefault()
  refetchList()

  api.enrollment
    .index()
    .then((data) => {
      enrollments.value = data
    })
    .catch()
  api.banner
    .index({ type: 'user_dashboard' })
    .then((data) => {
      banners.value = data
    })
    .catch()
  if (!userState.user) await userState.getUser()
  if (useNewStats.value) {
    // 新方式: learning_stats/daily_series が学習時間・完了数の両方を返す
    fetchTrackingData().catch(() => {})
  } else {
    // トラッキングデータの取得
    api.tracking
      .get(dateRange.value)
      .then((res) => {
        userTrackingData.value = res
      })
      .catch()
    // アクティビティデータの取得（学習完了数計算用）
    api.activity
      .get(0, dateRange.value)
      .then((res) => {
        activitiesData.value = res.activities || []
      })
      .catch()
  }
  api.userGoal.currentGoal()
    .then((data) => {
      userGoal.value = data
    })
    .catch((e) => {
      console.log(e)
    })
  api.userGoal.index()
    .then((userGoals) => {
      userGoalsCount.value = userGoals.length
    })
    .catch((e) => {
      console.log(e)
    })
  if (showAiChatMobile.value) {
    api.aiTutorAgent.index({
      targetableId: user.value!.currentSchoolId.toString(),
      targetableType: 'School'
    }).then((agents: any[]) => {
      const defaultAgent = agents[0]
      agentAvatarUrl.value = defaultAgent?.imageUrl || agentDefaultAvatar.value
    })
  }
})()

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createBlock(SubPage, {
    pageMode: pageMode.value,
    onSwitchMode: onSwitchMode
  }, {
    main_page: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["dashboard-container container-fix-padding", { 'with-ai-chat': schoolSetting.value && schoolSetting.value.useDashboardAi }])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["h-100", mobile.value ? 'd-flex flex-column' : (!mobile.value && showAiChatDesktop.value ? '' : 'd-flex flex-row')]),
          style: _normalizeStyle(!mobile.value && showAiChatDesktop.value ? { display: 'grid', gridTemplateColumns: `1fr ${rightPanelWidth.value}px` } : {})
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["dashboard-container-item p-0", mainContentClass.value])
          }, [
            (getBanner('user_dashboard_top'))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  innerHTML: getBanner('user_dashboard_top')?.bodyHtml
                }, null, 8 /* PROPS */, _hoisted_1))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_2, [
              (mobile.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(DashboardProgress, {
                        class: "w-50",
                        progressRate: learnProgressRate.value
                      }, null, 8 /* PROPS */, ["progressRate"]),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", null, [
                            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-overline" }, "今週の学習", -1 /* CACHED */)),
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("div", _hoisted_8, _toDisplayString(learnTimeToTimeJp.value), 1 /* TEXT */)
                            ])
                          ]),
                          _createVNode(UserTimeGoalChangeDialog, { update: updateTimeGoal })
                        ]),
                        _createVNode(DashboardTimeSummary, {
                          class: "d-flex align-end",
                          height: 70,
                          width: 100,
                          timeGraphData: timeGraphData.value
                        }, null, 8 /* PROPS */, ["timeGraphData"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_v_icon, { size: "small" }, {
                            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                              _createTextVNode("mdi-clock-time-five-outline", -1 /* CACHED */)
                            ]))]),
                            _: 1 /* STABLE */
                          }),
                          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "ms-1 text-caption" }, "学習時間", -1 /* CACHED */))
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("span", {
                            class: _normalizeClass(mobile.value ? 'text-h7' : 'text-h4')
                          }, _toDisplayString(totalLearnTimeToTimeJp.value), 3 /* TEXT, CLASS */)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_v_icon, { size: "small" }, {
                            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                              _createTextVNode("mdi-file-document-multiple-outline", -1 /* CACHED */)
                            ]))]),
                            _: 1 /* STABLE */
                          }),
                          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "ms-1 text-caption" }, "Act数", -1 /* CACHED */))
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createCommentVNode(" 表示は computedActivityCount を利用 "),
                          _createElementVNode("span", _hoisted_16, _toDisplayString(computedActivityCount.value), 1 /* TEXT */),
                          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-caption" }, "回", -1 /* CACHED */))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_v_icon, { size: "small" }, {
                            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                              _createTextVNode("mdi-file-document-multiple", -1 /* CACHED */)
                            ]))]),
                            _: 1 /* STABLE */
                          }),
                          _createElementVNode("span", _hoisted_19, _toDisplayString(customTexts.value.get('classroom_dashboard.consecutive_days') || '連続日数'), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("span", _hoisted_21, _toDisplayString(consecutiveDayCount.value), 1 /* TEXT */),
                          _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-caption" }, "日", -1 /* CACHED */))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: "d-flex pt-2 justify-space-between align-center px-3",
                      onClick: toActivity
                    }, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                            _createTextVNode("mdi-file-chart-outline", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }),
                        _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-overline ms-1" }, "学習レポート", -1 /* CACHED */))
                      ]),
                      _cache[12] || (_cache[12] = _createElementVNode("div", null, " > ", -1 /* CACHED */))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createCommentVNode(" Progress Section "),
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(DashboardProgress, { progressRate: learnProgressRate.value }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, _toDisplayString(customTexts.value.get('classroom_dashboard.this_week_goal') || '今週目標'), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, _toDisplayString(learnTimeToTimeJp.value), 1 /* TEXT */),
                              _createVNode(UserTimeGoalChangeDialog, { update: updateTimeGoal })
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("div", null, _toDisplayString(customTexts.value.get('classroom_dashboard.this_week_learning') || '今週の学習'), 1 /* TEXT */),
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_29, _toDisplayString(totalLearnTimeToTimeJp.value), 1 /* TEXT */)
                              ])
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["progressRate"])
                      ]),
                      _createCommentVNode(" Time Summary Section "),
                      _createElementVNode("div", _hoisted_30, [
                        _createVNode(DashboardTimeSummary, { timeGraphData: timeGraphData.value }, null, 8 /* PROPS */, ["timeGraphData"]),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, _toDisplayString(dateFormat(dateRange.value.startDate)) + " 〜 " + _toDisplayString(dateFormat(dateRange.value.endDate)), 1 /* TEXT */),
                          _createElementVNode("div", _hoisted_33, [
                            _createVNode(_component_v_btn, {
                              size: "x-small",
                              color: "primary",
                              onClick: toActivity
                            }, {
                              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                _createTextVNode(" 詳細見る ", -1 /* CACHED */)
                              ]))]),
                              _: 1 /* STABLE */
                            })
                          ])
                        ])
                      ]),
                      _createCommentVNode(" Counters Section "),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            _createVNode(_component_v_icon, { size: "small" }, {
                              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                _createTextVNode("mdi-file-document-multiple-outline", -1 /* CACHED */)
                              ]))]),
                              _: 1 /* STABLE */
                            }),
                            _createElementVNode("span", _hoisted_37, _toDisplayString(customTexts.value.get('classroom_dashboard.total_completed_count') || '学習完了数'), 1 /* TEXT */)
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_38, _toDisplayString(computedActivityCount.value), 1 /* TEXT */),
                            _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-caption" }, "回", -1 /* CACHED */))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _createVNode(_component_v_icon, { size: "small" }, {
                              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                _createTextVNode("mdi-file-document-multiple", -1 /* CACHED */)
                              ]))]),
                              _: 1 /* STABLE */
                            }),
                            _cache[17] || (_cache[17] = _createElementVNode("span", { class: "ms-1 text-caption" }, "連続日数", -1 /* CACHED */))
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_41, _toDisplayString(consecutiveDayCount.value), 1 /* TEXT */),
                            _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-caption" }, "日", -1 /* CACHED */))
                          ])
                        ])
                      ])
                    ])
                  ]))
            ]),
            _createCommentVNode(" 以下、ダッシュボード下部のその他コンテンツ "),
            (user.value && user.value.showDashboardInformation)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, _toDisplayString(user.value.showDashboardInformation.title), 1 /* TEXT */),
                      _createElementVNode("div", {
                        class: "text-small ms-2 border-default p-1 text-blue cursor-pointer",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (readInformation(user.value.showDashboardInformation)))
                      }, " 非表示にする ")
                    ]),
                    _createVNode(_component_v_divider, { class: "mt-2" }),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("p", {
                        class: "my-3 html-body",
                        innerHTML: user.value.showDashboardInformation.content
                      }, null, 8 /* PROPS */, _hoisted_46)
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            (unreadInformations.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_48, [
                      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "text-large" }, "お知らせ", -1 /* CACHED */)),
                      _createElementVNode("div", _hoisted_49, "未読: " + _toDisplayString(user.value?.unreadInformationsCount) + "件", 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(latestiUnreadInformations.value, (item, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: `item-${item.id}`
                        }, [
                          _createVNode(InformationView, {
                            item: item,
                            onClick: ($event: any) => (toInfo(item))
                          }, null, 8 /* PROPS */, ["item", "onClick"]),
                          (index < latestiUnreadInformations.value.length - 1)
                            ? (_openBlock(), _createBlock(_component_v_divider, { key: 0 }))
                            : _createCommentVNode("v-if", true)
                        ], 64 /* STABLE_FRAGMENT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _createVNode(_component_router_link, {
                        class: "text-blue cursor-pointer",
                        to: "/classroom/infors"
                      }, {
                        default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                          _createTextVNode(" すべてのお知らせを見る ", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      })
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            (currentUserGoal.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                  _createElementVNode("h3", _hoisted_53, [
                    _createVNode(_component_v_icon, { class: "me-1" }, {
                      default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                        _createTextVNode("mdi-bullseye-arrow", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }),
                    _createTextVNode(_toDisplayString(customTexts.value.get('classroom_dashboard.goal') || 'ゴール'), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _createVNode(_component_v_img, {
                        src: currentUserGoal.value.goal.image.url
                      }, null, 8 /* PROPS */, ["src"])
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("div", {
                        class: "text-h6",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (goToUserGoal(currentUserGoal.value))),
                        style: {"cursor":"pointer"}
                      }, _toDisplayString(currentUserGoal.value.goal.name), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_57, " 目標期間 " + _toDisplayString(dateFormat(userGoal.value!.startDate, 'YYYY/MM/DD')) + "～" + _toDisplayString(dateFormat(userGoal.value!.endDate, 'YYYY/MM/DD')), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("div", null, [
                          (userGoal.value!.isOutSchedule)
                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                key: 0,
                                color: "red",
                                "text-color": "white",
                                small: mobile.value
                              }, {
                                default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                  _createTextVNode(" 遅れてます ", -1 /* CACHED */)
                                ]))]),
                                _: 1 /* STABLE */
                              }, 8 /* PROPS */, ["small"]))
                            : (userGoal.value!.isLate)
                              ? (_openBlock(), _createBlock(_component_v_chip, {
                                  key: 1,
                                  color: "green",
                                  "text-color": "white",
                                  small: mobile.value
                                }, {
                                  default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                    _createTextVNode(" やや遅れています ", -1 /* CACHED */)
                                  ]))]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["small"]))
                              : (userGoal.value!.isOnSchedule)
                                ? (_openBlock(), _createBlock(_component_v_chip, {
                                    key: 2,
                                    color: "primary",
                                    small: mobile.value
                                  }, {
                                    default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                      _createTextVNode(" 順調 ", -1 /* CACHED */)
                                    ]))]),
                                    _: 1 /* STABLE */
                                  }, 8 /* PROPS */, ["small"]))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("div", _hoisted_59, " 残り日数" + _toDisplayString(userGoal.value!.daysRemaining) + "日 ", 1 /* TEXT */)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, [
                        _createVNode(_component_v_progress_circular, {
                          size: "150",
                          width: 20,
                          "model-value": userGoal.value!.progressRate,
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_62, [
                              _createElementVNode("span", _hoisted_63, _toDisplayString(userGoal.value!.progressRate), 1 /* TEXT */),
                              _cache[25] || (_cache[25] = _createTextVNode("% ", -1 /* CACHED */))
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["model-value"])
                      ]),
                      _createElementVNode("div", _hoisted_64, _toDisplayString(customTexts.value.get('classroom_dashboard.progress_rate') || '進捗率'), 1 /* TEXT */),
                      (totalUserGoalsCount.value > 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "mt-2 text-center text-blue cursor-pointer",
                            onClick: goToUserGoals
                          }, " ゴール他" + _toDisplayString(totalUserGoalsCount.value) + "つを全部見る ", 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("div", null, [
                (firstEnrollments.value.length > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("h3", _hoisted_66, _toDisplayString(customTexts.value.get('classroom_dashboard.class_in_progress') || '授業中の講座'), 1 /* TEXT */),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(firstEnrollments.value, (enrollment) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: `divider-${enrollment.id}`
                        }, [
                          _createVNode(_component_v_divider),
                          _createVNode(CourseMy, { enrollment: enrollment }, null, 8 /* PROPS */, ["enrollment"])
                        ], 64 /* STABLE_FRAGMENT */))
                      }), 128 /* KEYED_FRAGMENT */)),
                      (isMoreCourse.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                            _createVNode(_component_router_link, {
                              class: "show-more",
                              to: "/classroom/my-courses"
                            }, {
                              default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                _createTextVNode("もっと見る", -1 /* CACHED */)
                              ]))]),
                              _: 1 /* STABLE */
                            })
                          ]))
                        : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _cache[27] || (_cache[27] = _createElementVNode("h3", { class: "gray--text" }, "まだ受講中の講座はありません", -1 /* CACHED */)),
                      _cache[28] || (_cache[28] = _createElementVNode("a", {
                        class: "exams-list",
                        href: "/courses"
                      }, "講座一覧を見る", -1 /* CACHED */))
                    ], 64 /* STABLE_FRAGMENT */))
              ]),
              (exams.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                    _createElementVNode("h3", _hoisted_69, _toDisplayString(customTexts.value.get('classroom_dashboard.recent_tests') || '最近受けたテスト'), 1 /* TEXT */),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(exams.value.slice(0, 3), (exam, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createVNode(Exam, {
                          exam: exam,
                          isMine: true,
                          schoolSetting: schoolSetting.value,
                          onShowHistories: onShowHistories,
                          onFetchList: refetchList
                        }, null, 8 /* PROPS */, ["exam", "schoolSetting"])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */)),
                    (isMoreExam.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                          _createVNode(_component_router_link, {
                            class: "show-more",
                            to: "/classroom/my-exams"
                          }, {
                            default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                              _createTextVNode("もっと見る", -1 /* CACHED */)
                            ]))]),
                            _: 1 /* STABLE */
                          })
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _createCommentVNode(" Mobile banner for when AI chat is enabled "),
            (showAiChatMobile.value && getBanner('user_dashboard_sidebar_top'))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 4,
                  class: "mt-3 bg-white p-3",
                  innerHTML: getBanner('user_dashboard_sidebar_top')?.bodyHtml
                }, null, 8 /* PROPS */, _hoisted_71))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" AI Dashboard Chat - Mobile (FAB + Modal) "),
            (showAiChatMobile.value && agentAvatarUrl.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                  _createElementVNode("button", _hoisted_72, [
                    _createElementVNode("img", {
                      src: agentAvatarUrl.value,
                      alt: "agent",
                      class: "dashboard-chat-fab-img"
                    }, null, 8 /* PROPS */, _hoisted_73)
                  ]),
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("div", _hoisted_75, [
                      _createElementVNode("div", _hoisted_76, [
                        _cache[30] || (_cache[30] = _createElementVNode("div", { class: "modal-header" }, [
                          _createElementVNode("div", {
                            class: "h5 mb-0 modal-title",
                            id: "dashboard_ai_chatLabel"
                          }, " AIチャット "),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn-close",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                          })
                        ], -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_77, [
                          _createVNode(DashboardChatTabs, {
                            targetableType: 'School',
                            targetableId: schoolId.value.toString(),
                            threadId: dashboardChatThreadId.value,
                            hasSidebarBanner: hasDashboardTopBanner.value
                          }, null, 8 /* PROPS */, ["targetableId", "threadId", "hasSidebarBanner"])
                        ])
                      ])
                    ])
                  ])
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            (getBanner('user_dashboard_bottom'))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 6,
                  innerHTML: getBanner('user_dashboard_bottom')?.bodyHtml
                }, null, 8 /* PROPS */, _hoisted_78))
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */),
          _createCommentVNode(" Right Sidebar - Always show if available "),
          (!showAiChatDesktop.value && getBanner('user_dashboard_sidebar_top'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                _createElementVNode("div", {
                  innerHTML: getBanner('user_dashboard_sidebar_top')?.bodyHtml
                }, null, 8 /* PROPS */, _hoisted_80)
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" AI Dashboard Chat - Right Side "),
          (showAiChatDesktop.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                _createCommentVNode(" Resize Handle "),
                (!mobile.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "resize-handle",
                      onMousedown: startResize,
                      onDblclick: resetPanelWidth,
                      title: "ダブルクリックでデフォルトサイズにリセット"
                    }, [...(_cache[31] || (_cache[31] = [
                      _createElementVNode("div", { class: "resize-handle-line" }, null, -1 /* CACHED */)
                    ]))], 32 /* NEED_HYDRATION */))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" Show banner at top of AI chat sidebar if available "),
                (getBanner('user_dashboard_sidebar_top'))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "mb-1 banner-dashboard-chat",
                      innerHTML: getBanner('user_dashboard_sidebar_top')?.bodyHtml
                    }, null, 8 /* PROPS */, _hoisted_82))
                  : _createCommentVNode("v-if", true),
                _createVNode(DashboardChatTabs, {
                  ref_key: "dashboardChatTabs",
                  ref: dashboardChatTabs,
                  targetableType: 'School',
                  targetableId: schoolId.value.toString(),
                  threadId: dashboardChatThreadId.value,
                  hasSidebarBanner: hasDashboardTopBanner.value
                }, null, 8 /* PROPS */, ["targetableId", "threadId", "hasSidebarBanner"])
              ]))
            : _createCommentVNode("v-if", true)
        ], 6 /* CLASS, STYLE */)
      ], 2 /* CLASS */)
    ]),
    sub_page: _withCtx(() => [
      (subPageExam.value)
        ? (_openBlock(), _createBlock(Exam, {
            key: 0,
            exam: subPageExam.value,
            isMine: true,
            schoolSetting: schoolSetting.value,
            onFetchList: refetchList
          }, null, 8 /* PROPS */, ["exam", "schoolSetting"]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["pageMode"]))
}
}

})